import { api } from '../../../api/common/instances';

const state = () => ({
  isLoading: false,
  metaSaps: null,
  descriptions: null,
  addSuccess: null,
  delSuccess: null,
});

const getters = {};

const mutations = {
  getMetaSaps(state, list) {
    state.metaSaps = list;
  },
  getDescriptions(state, list) {
    state.descriptions = list;
  },
  updateDescription(state) {
    state.addSuccess = 'success';
  },
  // BEGIN::Added.by.KWShin.2022.09.19.
  // addSuccess에 'success'만 할당하고 이를 다시 반대의미로 해석하게 하는 값을 할당하지 않아
  // 값의 변화가 없으므로 addSuccess의 값을 지켜보는 쪽에서 오동작을 하게 된다.
  // 반대 의미의 값을 할당하는 로직 추가.
  nullifyAddSuccess(state) {
    state.addSuccess = null;
  },
  // FINISH::Added.by.KWShin.2022.09.19.
  deleteDescriptions(state) {
    state.delSuccess = 'success';
  },
};

const actions = {
  async getMetaSaps({ commit }, metaInfos) {
    if (!metaInfos) return;
    const { data } = await api.get(`/preference/meta-saps?systemId=${metaInfos.systemId}`);
    commit('getMetaSaps', data);
  },
  async getDescriptions({ commit }, metaInfos) {
    if (!metaInfos) return;
    const { data } = await api.get(`/preference/meta-sap-descriptions?systemId=${metaInfos.systemId}&tableName=${metaInfos.tableName}`);
    commit('getDescriptions', data);
  },
  async updateDescription({ dispatch, commit }, metaInfos) {
    if (!metaInfos) return;
    // Added.by.KWShin.2022.09.19.
    await commit('nullifyAddSuccess');
    const res = await api.post('/preference/meta-sap-descriptions', JSON.parse(JSON.stringify(metaInfos)));
    if (res.status === 200) {
      await commit('updateDescription');
      dispatch('getDescriptions', metaInfos);
      dispatch('getMetaSaps', metaInfos);
    }
  },
  async deleteDescriptions({ dispatch, commit }, metaInfos) {
    if (!metaInfos) return;
    const res = await api.delete(`/preference/meta-sap-descriptions/systemId/${metaInfos.systemId}/tableName/${metaInfos.tableName}/dateTime/${metaInfos.setectedDate}`);
    if (res.status === 200) {
      await commit('deleteDescriptions');
      dispatch('getDescriptions', metaInfos);
      dispatch('getMetaSaps', metaInfos);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
